import { render, staticRenderFns } from "./channelAttrSelect.vue?vue&type=template&id=757e407e&"
import script from "./channelAttrSelect.vue?vue&type=script&lang=ts&"
export * from "./channelAttrSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports